import React from 'react';
import { Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useLocation, useNavigate } from 'react-router-dom';
import { style, CrumActive, BreadCrumbsProps } from './BreadCrumbs-helper';
import { Breadcrumbs as ApexBreadcrumbs, Link } from '@biq/apex-ui';
import { PIPELINES_AND_STEPS_PATHS } from 'constants/pipelines-and-steps-paths';

export function Breadcrumbs(
    props: Readonly<BreadCrumbsProps>
): React.JSX.Element {
    const { status, breadCrumData, breadCrumType, breadCrumLastItem } = props;
    let location = useLocation();
    const navigate = useNavigate();
    const pathSegments = location.pathname.split('/');
    const formattedNames = (name: string): string => {
        const decoded = decodeURIComponent(name);

        const words = decoded.split('-');
        const capitalizedWords = words.map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1)
        );
        return capitalizedWords.join(' ');
    };
    const getCrumActive = (data: string[], lastCrumn: string): string => {
        const strJoin = data.filter((item) => item !== '').join('-');
        let finalStr;
        if (CrumActive[strJoin as keyof typeof CrumActive]) {
            finalStr = CrumActive[strJoin as keyof typeof CrumActive];
        } else if (strJoin.includes('edges')) {
            finalStr = 'Edit Edge Definition';
        } else if (strJoin.includes('edit-user-wallet')) {
            finalStr = 'Edit User Wallet';
        } else if (strJoin.includes('edit-system-wallet')) {
            finalStr = 'Edit System Wallet';
        } else if (strJoin.includes('edit-user-group')) {
            finalStr = 'Edit User Group';
        } else if (strJoin.includes('glossary-metadata')) {
            finalStr = 'Edit Glossary';
        } else {
            finalStr = formattedNames(lastCrumn);
        }
        return finalStr;
    };
    const getCookedNavlink = (linkParams: string): void => {
        if (
            status === 'update' &&
            linkParams &&
            (breadCrumType === 'Consent_Contract' ||
                breadCrumType === 'Smart_Contract')
        ) {
            navigate(`/${linkParams}`, {
                state: breadCrumData,
            });
        } else if (linkParams === 'steps') {
            navigate(`${PIPELINES_AND_STEPS_PATHS.LANDING_PAGE}?option=Steps`);
        } else {
            navigate(`/${linkParams || 'dashboard'}`);
        }
    };
    const getCrumb = (): React.JSX.Element[] => {
        const breadcrumbItems = pathSegments.slice(0, 3);
        let lastItem = breadcrumbItems.pop();

        const breadcrumbs: React.JSX.Element[] = breadcrumbItems.map((item) => {
            let displayText;
            if (item === 'edges') {
                displayText = 'Edge Definitions';
            } else if (item === 'dictionaries') {
                displayText = 'Dictionaries';
            } else if (item === 'wallets-and-groups') {
                displayText = 'Wallets & Groups';
            } else if (item === 'glossary-metadata') {
                displayText = 'Glossary';
            } else {
                displayText = item ? formattedNames(item) : 'Home';
            }

            return (
                <Link
                    key={item}
                    underline='always'
                    onClick={(): void => getCookedNavlink(item)}
                >
                    {displayText}
                </Link>
            );
        });
        if (breadCrumLastItem || lastItem) {
            lastItem = (breadCrumLastItem || lastItem) ?? '';

            breadcrumbs.push(
                <Typography
                    color='text.primary'
                    sx={style.breadFontSize}
                    key='lastItem'
                    component={'span'}
                >
                    {getCrumActive(pathSegments, lastItem)}
                </Typography>
            );
        }

        return breadcrumbs;
    };
    return (
        <ApexBreadcrumbs
            aria-label='breadcrumb'
            separator={<NavigateNextIcon fontSize='small' />}
            sx={style.breadCrumbStyles}
        >
            {React.Children.toArray(
                getCrumb().map((crumb) => (
                    <Typography
                        color='textPrimary'
                        sx={style.breadFontSize}
                        component={'p'}
                    >
                        {crumb}
                    </Typography>
                ))
            )}
        </ApexBreadcrumbs>
    );
}
